(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("admin-pages", [], factory);
	else if(typeof exports === 'object')
		exports["admin-pages"] = factory();
	else
		root["admin-pages"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 